import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">ThugRatz · Bold Streetwear</p>
        <h1>Unleash Your Style.</h1>
        <p className="lede">
          Discover the latest in bold and edgy streetwear designed for the fearless. Stand out and express yourself with our unique collections tailored for young adults.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Make a Statement</h2>
          <p>
            Our pieces are crafted to turn heads and spark conversations. Embrace your individuality with styles that push boundaries.
          </p>
        </article>
        <article>
          <h2>Quality Meets Attitude</h2>
          <p>
            Each item is designed with premium materials and a fearless attitude, ensuring you not only look good but feel confident.
          </p>
        </article>
        <article>
          <h2>Join the Movement</h2>
          <p>
            Be part of a community that celebrates self-expression and creativity. Follow us for the latest drops and exclusive offers.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;